var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../../service/api.service';
import { ContentBaseService } from '../../../../../component/base/contentbase.service';
import { Option } from '../../../../../models/option/option';
import { ItemBase } from '../../../../../models/item/item-base';
var KtsTaskConditionService = /** @class */ (function (_super) {
    __extends(KtsTaskConditionService, _super);
    function KtsTaskConditionService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.step = {};
        _this.task = {};
        _this._subject = new BehaviorSubject(null);
        return _this;
    }
    Object.defineProperty(KtsTaskConditionService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    KtsTaskConditionService.prototype.setProjectMId = function (id) {
        this._subject.next(id);
    };
    KtsTaskConditionService.prototype.setStep = function (key, options) {
        this.step[key] = options;
    };
    KtsTaskConditionService.prototype.getStep = function (key) {
        return this.step[key] || [];
    };
    KtsTaskConditionService.prototype.setTask = function (key, options) {
        this.task[key] = options;
    };
    KtsTaskConditionService.prototype.getTask = function (key) {
        return this.task[key] || [];
    };
    KtsTaskConditionService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsTaskConditionService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return KtsTaskConditionService;
}(ContentBaseService));
export { KtsTaskConditionService };
var TaskCondition = /** @class */ (function () {
    function TaskCondition(key, msg) {
        this.cols = [];
        this.cols = [];
        this.cols.push(Object.assign(new ItemBase(), {
            key: '$' + key + '.task_u.task_m.step',
            controlType: 'select',
            params: { options: [] }
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            key: '$' + key + '.task_u.task_m.id',
            controlType: 'select',
            params: { options: [] }
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            controlType: 'label',
            label: ' ' + msg['au.COMPONENT.KtsTaskConditionComponent.label.plan_date'] + ':'
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            key: '$' + key + '.$rangeFrom.task_u.plan_date',
            controlType: 'date'
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            controlType: 'label',
            label: '~'
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            key: '$' + key + '.$rangeTo.task_u.plan_date',
            controlType: 'date'
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            controlType: 'label',
            label: ' ' + msg['au.COMPONENT.KtsTaskConditionComponent.label.status'] + ':'
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            key: '$' + key + '.task_u.is_complete',
            controlType: 'select',
            params: {
                options: [
                    { code: false, display: msg['au.COMPONENT.KtsTaskConditionComponent.select.notCompleted'] },
                    { code: true, display: msg['au.COMPONENT.KtsTaskConditionComponent.select.completion'] }
                ]
            }
        }));
    }
    return TaskCondition;
}());
export { TaskCondition };
var TaskOption = /** @class */ (function (_super) {
    __extends(TaskOption, _super);
    function TaskOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TaskOption;
}(Option));
export { TaskOption };
//# sourceMappingURL=task-condition.service.js.map